const filterEmpty = (array) => array.filter((item) => item !== null && item !== undefined)
const filterClones = (array) => [...new Set(array)]

export { filterEmpty, filterClones }
